import { render, staticRenderFns } from "./firstpage.vue?vue&type=template&id=64bdc942&scoped=true&"
import script from "./firstpage.vue?vue&type=script&lang=js&"
export * from "./firstpage.vue?vue&type=script&lang=js&"
import style0 from "./firstpage.vue?vue&type=style&index=0&id=64bdc942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bdc942",
  null
  
)

export default component.exports